import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import useRoleSubmit from "hooks/useRoleSubmit";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputName";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";

const RoleDrawer = ({ id }) => {
  const { register, handleSubmit, loading, onSubmit, errors } =
    useRoleSubmit(id);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Update Role" />
        ) : (
          <Title register={register} title="Add Role" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="overflow-y-scroll flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea required label="Role" />
                    <InputArea
                      register={register}
                      label="Role"
                      name="name"
                      type="text"
                      placeholder="Role"
                    />
                    <Error errorName={errors.name} />
                  </div>
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Submit"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default RoleDrawer;
